import { useCallback, useRef } from 'react';

interface UseSmartComposerFocusArgs {
  focus: () => void;
}

export const useSmartComposerFocus = ({ focus }: UseSmartComposerFocusArgs) => {
  const editorFocusedRef = useRef(false);
  const suppressRefocusRef = useRef(false);

  const onEditorFocus = useCallback(() => {
    editorFocusedRef.current = true;
    suppressRefocusRef.current = false;
  }, []);

  const onEditorBlur = useCallback(() => {
    editorFocusedRef.current = false;
  }, []);

  const onTranscriptEngage = useCallback(() => {
    suppressRefocusRef.current = true;
  }, []);

  const focusComposerSmart = useCallback(() => {
    if (suppressRefocusRef.current && !editorFocusedRef.current) return;
    focus();
  }, [focus]);

  const focusComposerAlways = useCallback(() => {
    suppressRefocusRef.current = false;
    editorFocusedRef.current = true;
    focus();
  }, [focus]);

  return {
    onEditorFocus,
    onEditorBlur,
    onTranscriptEngage,
    focusComposerSmart,
    focusComposerAlways,
  };
};
